/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import LayoutModel from 'cio/models/layout';

const IMAGE_URLS: Record<string, string> = {
  Basic: new URL('cio/assets/images/basic.png', import.meta.url).toString(),
  Announcement: new URL('cio/assets/images/announcement.png', import.meta.url).toString(),
  'Call to Action': new URL('cio/assets/images/call-to-action.png', import.meta.url).toString(),
  Menu: new URL('cio/assets/images/menu.png', import.meta.url).toString(),
  Newsletter: new URL('cio/assets/images/newsletter.png', import.meta.url).toString(),
};

interface LayoutStarterCardArgs {
  item: LayoutModel;
  selectedStarterId: string;
  onSelect: (item: LayoutModel) => unknown;
}

export default class LayoutStarterCard extends Component<LayoutStarterCardArgs> {
  get isBlankStarter() {
    return this.args.item.name === 'Start from scratch';
  }

  get noImage() {
    return isEmpty((this.args.item as any).preview_path);
  }

  get imageURL() {
    return IMAGE_URLS[this.args.item.name];
  }

  @action
  onSelect(item: LayoutModel) {
    this.args.onSelect?.(item);
  }
}
